import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Accordion, Icon } from 'semantic-ui-react';

const Groups = ({ groups, title, path }) => (
    <Accordion>
        <Accordion.Title>
            <Icon name='dropdown' />
            {title}
        </Accordion.Title>
        <Accordion.Content>
            {groups.map(group => (
                    <div key={group.name}>
                        <NavLink className="group-link" to={`${path}/${group.name}`}>
                            {group.name}
                        </NavLink>
                    </div>
                ))}
        </Accordion.Content>
    </Accordion>
);

Groups.propTypes = {
    groups: PropTypes.arrayOf(PropTypes.object)
};

export default Groups;



// WEBPACK FOOTER //
// ./src/Groups.js